import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";

import Toast from "../../../molecules/Toast";
import { parseQueryParams } from "../../../libs/Util";
import {
  Context,
  login,
  authenticationPath,
  clearOTT,
} from "../../../teacherStore";
import LoginForm from "../../../templates/teacher/Login/LoginForm";

export default () => {
  const { dispatch, state } = React.useContext(Context);
  const history = useHistory();
  const location = useLocation();
  const [showMsg, setShowMsg] = React.useState({
    text: "",
    type: "",
  });
  const loginFunc = React.useCallback(
    (email: string, password: string, remember: boolean) => {
      dispatch(login(email, password, remember));
    },
    [dispatch],
  );

  React.useEffect(() => {
    if (state.ott) {
      history.push(`${authenticationPath}/${state.ott}`);
      dispatch(clearOTT());
    }
  }, [dispatch, history, state.ott]);

  React.useEffect(() => {
    const message = parseQueryParams()["message"];

    if (message) {
      setShowMsg({
        text: message,
        type: "error",
      });

      const searchParams = new URLSearchParams(location.search);
      searchParams.delete("message");

      history.replace({
        pathname: location.pathname,
        search: searchParams.toString() ? `?${searchParams.toString()}` : "",
        hash: location.hash,
      });
    }
  }, [history, location.hash, location.pathname, location.search]);

  return (
    <>
      {showMsg.text && (
        <Toast
          onClose={() => setShowMsg({ text: "", type: "" })}
          message={showMsg}
        />
      )}
      <LoginForm login={loginFunc} />
    </>
  );
};
